import { render, staticRenderFns } from "./TrademarkProvisionalCaseInstructionList.vue?vue&type=template&id=9bb84f0e&"
import script from "./TrademarkProvisionalCaseInstructionList.vue?vue&type=script&lang=js&"
export * from "./TrademarkProvisionalCaseInstructionList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkProvisionalCaseInstructionList.vue?vue&type=style&index=0&id=9bb84f0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports